import Const from './const';

let Data = {
    isGuest: isGuest,
    getToken: getToken,
    setToken: setToken,
    getUser: getUser,
    setUser: setUser,
    getCurrentAccount: getCurrentAccount,
    getRecentAccountList: getRecentAccountList,
    setRecentAccountList: setRecentAccountList,
    saveRecentAccount: saveRecentAccount,
    removeRecentAccount: removeRecentAccount,
    clearRecentAccountList: clearRecentAccountList,
    switchRecentAccount: switchRecentAccount,
    getUserType: getUserType,
    setUserType: setUserType,
    getProject: getProject,
    setProject: setProject,
    getProjectId: getProjectId,
    get: get,
    set: set,
    remove: remove,
    clearAuthData: clearAuthData,
    setLang: setLang,
    getLang: getLang
};

function isGuest() {
    let token = getToken();
    return !token;
}

function getKey(key) {
    return Const.DATA.KEY_PREFIX + key;
}

function get(key) {
    if (key) {
        key = getKey(key);
        return JSON.parse(window.localStorage.getItem(key));
    }
}

function set(key, val) {
    if (key) {
        key = getKey(key);
        return window.localStorage.setItem(key, JSON.stringify(val));
    }
}

function remove(key) {
    if (key) {
        key = getKey(key);
        return window.localStorage.removeItem(key);
    }
}


function getToken() {
    let key = Const.DATA.KEY_TOKEN;
    return get(key);
}

function setToken(token) {
    let key = Const.DATA.KEY_TOKEN;
    return set(key, token);
}

function getUser() {
    let key = Const.DATA.KEY_USER;
    return get(key);
}

function setUser(user) {
    let key = Const.DATA.KEY_USER;
    return set(key, user);
}

function getCurrentAccount() {
    let user = getUser();
    if (!user) {
        return '';
    }
    return user.email || user.username || user.phone || '';
}

function getRecentAccountList() {
    let key = Const.DATA.KEY_RECENT_ACCOUNT_LIST;
    let recentAccountList = get(key);
    return Array.isArray(recentAccountList) ? recentAccountList : [];
}

function setRecentAccountList(recentAccountList) {
    let key = Const.DATA.KEY_RECENT_ACCOUNT_LIST;
    return set(key, recentAccountList);
}

function saveRecentAccount(accountInfo) {
    if (!accountInfo || !accountInfo.account || !accountInfo.token || !accountInfo.user) {
        return;
    }
    let recentAccountList = getRecentAccountList().filter(item => item && item.account !== accountInfo.account);
    recentAccountList.unshift({
        account: accountInfo.account,
        user_name: accountInfo.user_name || '',
        role: accountInfo.role,
        avatar: accountInfo.avatar || '',
        token: accountInfo.token,
        user: accountInfo.user,
        last_login_time: Date.now()
    });
    recentAccountList = recentAccountList.slice(0, 5);
    return setRecentAccountList(recentAccountList);
}

function removeRecentAccount(account) {
    if (!account) {
        return;
    }
    let recentAccountList = getRecentAccountList().filter(item => item && item.account !== account);
    return setRecentAccountList(recentAccountList);
}

function clearRecentAccountList() {
    let key = Const.DATA.KEY_RECENT_ACCOUNT_LIST;
    return remove(key);
}

function switchRecentAccount(account) {
    if (!account) {
        return false;
    }
    let recentAccountList = getRecentAccountList();
    let targetAccount = recentAccountList.find(item => item && item.account === account);
    if (!targetAccount || !targetAccount.token || !targetAccount.user) {
        return false;
    }
    setToken(targetAccount.token);
    setUser(targetAccount.user);
    saveRecentAccount({
        account: targetAccount.account,
        user_name: targetAccount.user_name,
        role: targetAccount.role,
        avatar: targetAccount.avatar,
        token: targetAccount.token,
        user: targetAccount.user
    });
    return true;
}

function getUserType() {
    let key = Const.DATA.KEY_USER_TYPE;
    return get(key);
}

function setUserType(useType) {
    let key = Const.DATA.KEY_USER_TYPE;
    return set(key, useType);
}

function getProject() {
    let key = Const.DATA.KEY_PROJECT;
    return get(key);
}

function setProject(project) {
    let key = Const.DATA.KEY_PROJECT;
    return set(key, project);
}

function getProjectId() {
    let key = Const.DATA.KEY_PROJECT;
    let project = get(key);
    return project && project.id;
}
function setLang(lang) {
    let key = Const.DATA.KEY_LANG;
    return set(key, lang);
}

function getLang() {
    let key = Const.DATA.KEY_LANG;
    let lang = get(key);
    return lang;
}

function clearAuthData() {
    setToken('');
    setUser('');
}

export default Data
